import { DropdownWrapper } from '@anm/components/Dropdown';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { ColorPreviewProps, ColorPreviewVariant } from './types';

export const ColorField = styled.div`
  display: flex;
  width: 100%;
  border-radius: 5px;
  border: solid 1px ${({ theme }) => theme.inputBorder};
`;

const colorInputMobile = media.phone`
  font-size: 14px;
`;

export const ColorInput = styled.input`
  margin: 0;
  outline: none;
  color: ${({ theme }) => theme.textColor};
  padding: 0 10px;
  font-size: 16px;
  width: inherit;
  min-height: 38px;
  background-color: ${({ theme }) => theme.inputBg};
  border: 0;
  border-radius: 5px;
  ${colorInputMobile};
`;

const variants: { [key in ColorPreviewVariant]: ReturnType<typeof css> } = {
  left: css`
    width: 40px;
    height: 40px;
    border-radius: 5px 0 0 5px;
    border-right: 1px solid rgba(1, 83, 130, 0.2);
  `,
  inside: css`
    width: 32px;
    height: 32px;
    border-radius: 3px;
    margin: 4px;
    border: 1px solid rgba(0, 56, 87, 0.2);
  `,
  square: css`
    width: 40px;
    height: 40px;
    border-radius: 5px;
  `
};

export const ColorPreview = styled.div<ColorPreviewProps>`
  flex-shrink: 0;
  box-sizing: border-box;
  background: ${({ color }) => color || 'transparent'};

  ${({ variant }) => variants[variant]}
`;

const squareStyles = css`
  width: auto;
  display: inline-block;

  ${ColorField} {
    width: auto;
    display: inline-block;
  }
`;

export const Wrapper = styled.div<Pick<ColorPreviewProps, 'variant'>>`
  width: 100%;
  ${({ variant }) => variant === 'square' && squareStyles}
  ${DropdownWrapper} {
    cursor: pointer;
    :hover {
      background: none;
    }
  }
`;

export const InputWrapper = styled.div`
  margin-top: 15px;
  ${ColorInput} {
    border: 1px solid ${({ theme }) => theme.inputBorder};
    border-radius: 5px;
    max-width: 200px;
  }
`;
